import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import DatePicker from 'components/common/DatePicker';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import BaseService from 'services/BaseService';
import TextHelpers from 'helpers/TextHelpers';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class OtherDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const instructor = await BaseService.callAPI('instructor/get-other/' + this.props.instructor.id);
        this.setState({
            instructor,
            isLoading: false
        });
    }

    async save() {
        const { setIsBusy, setIsChanged } = this.props;
        const { instructor } = this.state;
        setIsBusy(true);
        this.setState({ isLoading: true });
        await BaseService.callAPI('instructor/save-other', instructor);
        setIsBusy(false);
        setIsChanged(false);
        this.setState({ isLoading: false });
        BootboxHelper.alert('Changes saved');
    }

    updateFields(values) {
        const instructor = { ...this.state.instructor };
        for (var fieldName in values) {
            const value = values[fieldName];
            instructor[fieldName] = value;
            if (fieldName == 'isExistingAAI' && value) {
                instructor.onboardDateVendor = null;
            }
        }
        this.setState({ instructor });
        this.props.setIsChanged(true, () => this.save());
    }

    render() {
        const { instructor, loginInfo } = this.props;
        const { isLoading } = this.state;
        if (isLoading) {
            return (<Loader fullPage />);
        }
        return (<>
            {instructor.isAvailableILT && this.renderTravel()}
            {loginInfo.isAdmin && this.renderOther()}
        </>);
    }

    renderTravel() {
        const { loginInfo, isEditMode } = this.props;
        const { instructor } = this.state;

        return (<>
            <h2>ILT Travel Details</h2>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Maximum Travel Distance</Form.Label>
                        {isEditMode ?
                            <select
                                className="form-control"
                                value={instructor.maxTravelDistance || ''}
                                onChange={e => this.updateFields({ maxTravelDistance: e.target.value })}
                            >
                                <option value="">(Unspecified)</option>
                                <option value="50">Up to 50km</option>
                                <option value="100">Up to 100km</option>
                                <option value="200">Up to 200km</option>
                                <option value="500">Up to 500km</option>
                                <option value="1000">Up to 1000km</option>
                                <option value="99999">Any distance</option>
                            </select> :
                            <p>{TextHelpers.formatMaxTravelDistance(instructor.maxTravelDistance)}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Maximum Frequency (per month)</Form.Label>
                        {isEditMode ?
                            <select
                                className="form-control"
                                value={instructor.maxDeliveriesPerMonth || ''}
                                onChange={e => this.updateFields({ maxDeliveriesPerMonth: e.target.value })}
                            >
                                <option value="">(Unspecified)</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="99999">Unrestricted</option>
                            </select> :
                            <p>{TextHelpers.formatMaxDeliveries(instructor.maxDeliveriesPerMonth)}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Your visa requirements within this geo</Form.Label>
                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                value={instructor.visaRequirements || ''}
                                onChange={e => this.updateFields({ visaRequirements: e.target.value })}
                                rows={1}
                            /> :
                            <p>{instructor.visaRequirements || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    {loginInfo.isAdmin &&
                        <Form.Group className="mb-3">
                            <Form.Label>Max Frequency Notes</Form.Label>
                            {isEditMode ?
                                <ExpandingTextArea
                                    className="form-control"
                                    value={instructor.iltFrequencyNotes || ''}
                                    onChange={e => this.updateFields({ iltFrequencyNotes: e.target.value })}
                                    rows={1}
                                /> :
                                <p>{instructor.iltFrequencyNotes || '—'}</p>
                            }
                        </Form.Group>
                    }

                </Col>

            </Row>

            {loginInfo.isAdmin && 
                <Form.Group>
                    <Form.Label>Instructor Comments</Form.Label>
                    {isEditMode ?
                        <ExpandingTextArea
                            className="form-control"
                            value={instructor.iltComments || ''}
                            onChange={e => this.updateFields({ iltComments: e.target.value })}
                            rows={2}
                        /> :
                        <p>{instructor.iltComments || '—'}</p>
                    }
                </Form.Group>
            }

        </>);
    }

    renderOther() {
        const { isEditMode, loginInfo } = this.props;
        const { instructor } = this.state;
        const isProspectApproved = (instructor.type == 'Prospect' && instructor.prospectType == 'Approved');

        return (<>

            <h2>Other details not visible to the instructor</h2>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Mobile number</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={instructor.mobileNumber || ''}
                                onChange={e => this.updateFields({ mobileNumber: e.target.value })}
                            /> :
                            <p>{instructor.mobileNumber || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Landline number</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={instructor.landlineNumber || ''}
                                onChange={e => this.updateFields({ landlineNumber: e.target.value })}
                            /> :
                            <p>{instructor.landlineNumber || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Other email address(es)</Form.Label>
                        {isEditMode ?
                            <input
                                className="form-control"
                                type="text"
                                value={instructor.otherEmails || ''}
                                onChange={e => this.updateFields({ otherEmails: e.target.value })}
                            /> :
                            <p>{instructor.otherEmails || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="3">

                    <Form.Group className="mb-3">
                        <Form.Label>Source</Form.Label>
                        {isEditMode ?
                            <select
                                className="form-control"
                                value={instructor.source || ''}
                                onChange={e => this.updateFields({ source: e.target.value })}
                            >
                                <option value="">(Select)</option>
                                <option value="RecruitedByGoCourses">Recruited by Go Courses</option>
                                <option value="ReferredByVendor">Referred by vendor</option>
                                <option value="Other">Other</option>
                            </select> :
                            <p>{this.getSourceName() || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="3">

                    <Form.Group className="mb-3">
                        <Form.Label>Source Details</Form.Label>
                        {isEditMode ?
                            <input
                                type="text"
                                className="form-control"
                                value={instructor.sourceDetails || ''}
                                onChange={e => this.updateFields({ sourceDetails: e.target.value })}
                            /> :
                            <p>{this.sourceDetails || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="3">

                    <Form.Group className="mb-3">
                        <Form.Label>Onboard date (Go Courses)</Form.Label>
                        {isEditMode ?
                            <DatePicker
                                className="form-control"
                                selected={instructor.onboardDateGoCourses ? new Date(instructor.onboardDateGoCourses) : null}
                                onChange={value => this.updateFields({ onboardDateGoCourses: value })}
                            /> :
                            <p>{instructor.onboardDateGoCourses ? moment(instructor.onboardDateGoCourses).format('DD/MM/YYY') : '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="3">

                    <Form.Group className="mb-3">
                        <Form.Label>Onboard date (Vendor)</Form.Label>
                        {isEditMode ?
                            <DatePicker
                                className="form-control"
                                selected={instructor.onboardDateVendor ? new Date(instructor.onboardDateVendor) : null}
                                onChange={value => this.updateFields({ onboardDateVendor: value })}
                                placeholder={instructor.isExistingAAI ? 'N/A' : ''}
                            /> :
                            <p>{instructor.onboardDateVendor ? moment(instructor.onboardDateVendor).format('DD/MM/YYY') : '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>{instructor.status == 'Candidate' || instructor.activeStatus != 'Active' ? 'Est. go-live' : 'Go-live'} date</Form.Label>
                        {isEditMode ?
                            <DatePicker
                                className="form-control"
                                selected={instructor.goLiveDate ? new Date(instructor.goLiveDate) : null}
                                onChange={value => this.updateFields({ goLiveDate: value })}
                            /> :
                            <p>{instructor.goLiveDate ? moment(instructor.goLiveDate).format('DD/MM/YYY') : '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="mb-3">
                        {isEditMode ? <>
                            <Form.Check
                                type="checkbox"
                                label="Existing AAI"
                                id="is-existing-aai"
                                checked={isProspectApproved || instructor.isExistingAAI || false}
                                readOnly={isProspectApproved || !isEditMode}
                                disabled={isProspectApproved || !isEditMode}
                                onChange={e => this.updateFields({ isExistingAAI: e.target.checked })}
                            />
                        </> : <>
                            <p>{instructor.isPriority ? <>Priority instructor (<span className="fa fa-star" />)</> : ''}</p>
                        </>}
                    </Form.Group>

                    {/*
                    {loginInfo.geo == 'EMEA' &&
                    TODO
                        <Form.Group className="mb-3">
                            <Form.Label>Show on other portals</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="APJC"
                                id="cross-geo-apjc"
                                checked={instructor.isCrossGeo || false}
                                readOnly={!isEditMode}
                                onChange={e => this.updateFields({ isCrossGeo: e.target.checked })}
                            />
                        </Form.Group>
                    }
                    */}

                </Col>

                <Col md="6">

                    <Form.Group className="mb-3">
                        <Form.Label>Vendor Email Address</Form.Label>

                        {isEditMode ?
                            <input
                                className="form-control"
                                type="email"
                                value={instructor.vendorUniqueKey1 || ''}
                                onChange={e => this.updateFields({ vendorUniqueKey1: e.target.value })}
                            /> :
                            <p>{instructor.vendorUniqueKey1 || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>

            <Row>

                <Col md="6">

                    <Form.Group className="">
                        <Form.Label>Booking notes/warnings</Form.Label>

                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                type="email"
                                value={instructor.bookingNotes || ''}
                                onChange={e => this.updateFields({ bookingNotes: e.target.value })}
                                rows={4}
                            /> :
                            <p>{instructor.bookingNotes || '—'}</p>
                        }
                    </Form.Group>

                </Col>

                <Col md="6">

                    <Form.Group className="">
                        <Form.Label>Alternative names (one per line)</Form.Label>

                        {isEditMode ?
                            <ExpandingTextArea
                                className="form-control"
                                type="email"
                                value={instructor.alternativeNames.join('\r\n') || ''}
                                onChange={e => this.updateFields({ alternativeNames: e.target.value.split(/\r\n|\r|\n/g) })}
                                rows={4}
                            /> :
                            <p>{instructor.alternativeNames || '—'}</p>
                        }
                    </Form.Group>

                </Col>

            </Row>
        </>);
    }

    getSourceName() {
        const { instructor } = this.state;
        switch (instructor.source) {
            case 'RecruitedByGoCourses': return 'Recruited by Go Courses';
            case 'ReferredByVendor': return 'Referred by vendor';
        }
        return instructor.source;
    }
}

export default OtherDetails;